import React, { createContext, useContext, useEffect } from 'react';

const ThemeContext = createContext();

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    // Return defaults if used outside provider - always dark
    return {
      isDarkMode: true,
      setIsDarkMode: () => {}
    };
  }
  return context;
};

/**
 * ThemeProvider - Now enforces dark mode only
 * The app is permanently in dark mode for consistency
 */
export const ThemeProvider = ({ children }) => {
  // Always dark mode
  const isDarkMode = true;
  const setIsDarkMode = () => {}; // No-op since we're always dark

  useEffect(() => {
    // Ensure dark mode class is always applied
    document.documentElement.classList.add('dark');
    
    // Save preference (always dark)
    try {
      localStorage.setItem('theme', 'dark');
    } catch (e) {
      // localStorage not available
    }
  }, []);

  const value = {
    isDarkMode: true,
    setIsDarkMode: () => {},
    toggleTheme: () => {}
  };

  return (
    <ThemeContext.Provider value={value}>
      {children}
    </ThemeContext.Provider>
  );
};

export default ThemeContext;
